






import Vue from 'vue'
import { LayoutApp } from '@/layouts'

export default Vue.extend({
    name: 'App',

    components: { LayoutApp },
})
